import { render, staticRenderFns } from "./AccountingParentBar.component.vue?vue&type=template&id=3a1a808d&scoped=true"
import script from "./AccountingParentBar.component.vue?vue&type=script&lang=js"
export * from "./AccountingParentBar.component.vue?vue&type=script&lang=js"
import style0 from "./AccountingParentBar.component.vue?vue&type=style&index=0&id=3a1a808d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a808d",
  null
  
)

export default component.exports